<div class="l" *ngFor='let item of [].constructor(count)'>
  <div class='item'>
    <app-skeleton-loader [Cwidth]="cwidth" [Cheight]="cheight" [Rwidth]="rwidth" [Rheight]="rheight" [circle]="circle" ></app-skeleton-loader>
  </div>
</div>

